import './Footer.css';
import FooterAbout from './FooterAbout';
import QuickLinksSection from './QuickLinksSection';
import { SocialLinksContainer } from './SocialLink';
import { SOCIAL_LINKS, DESKTOP_QUICK_LINKS, MOBILE_QUICK_LINKS, MOBILE_BREAKPOINT } from './footerConstants';
import {useState,useEffect} from 'react';

const Footer = () => {
    // const windowWidth = window.innerWidth;
    // const isMobile = windowWidth <= MOBILE_BREAKPOINT;
    const [isMobile, setIsMobile]=useState(window.innerWidth <= MOBILE_BREAKPOINT);


    const DesktopFooter = () => (
        <section className='footer-section'>
            <div className="footer-container">
                <FooterAbout />
                {DESKTOP_QUICK_LINKS.map((section, index) => (
                    <QuickLinksSection
                        key={index}
                        title={section.title}
                        links={section.links}
                        isMobile={false}
                    />
                ))}
                <SocialLinksContainer socialLinks={SOCIAL_LINKS} />
            </div>
        </section>
    );

    const MobileFooter = () => (
        <section className='footer-section'>
            <div className="footer-container">
                <FooterAbout />
                <SocialLinksContainer socialLinks={SOCIAL_LINKS} />
                {MOBILE_QUICK_LINKS.map((section, index) => (
                    <QuickLinksSection
                        key={index}
                        title={section.title}
                        links={section.links}
                        isMobile={true}
                    />
                ))}
            </div>
        </section>

       
    );

     
        useEffect(() => {
            const hendleSizeChange=()=>{
                setIsMobile(window.innerWidth<=MOBILE_BREAKPOINT);
            }

            window.addEventListener('resize',hendleSizeChange);
            return()=>{
                window.removeEventListener('resize',hendleSizeChange);
            }
        }, []);

    return isMobile ? <MobileFooter /> : <DesktopFooter />;
};

export default Footer;